var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessPaymentOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 255,
    viewBox: "0 0 283 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.699,
    cy: 150.184,
    r: 104.816,
    fill: "#F2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.686 252.171L65.8708 226.291C59.6782 223.256 58.3433 215.012 63.2621 210.178L170.99 104.315C173.617 101.734 177.451 100.805 180.969 101.899L257.616 125.738C265.218 128.103 267.143 137.97 260.988 143.019L129.428 250.923C126.401 253.407 122.203 253.894 118.686 252.171Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.88 240.411L65.8903 213.501C59.6915 210.467 58.356 202.215 63.2816 197.381L174.4 88.3336C177.264 85.5224 181.532 84.6962 185.239 86.2355L256.209 115.706C263.139 118.584 264.548 127.787 258.796 132.606L131.698 239.094C128.669 241.632 124.43 242.148 120.88 240.411Z",
    fill: "#3681D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0585 28.8436C60.6562 26.6129 63.4446 25.8658 65.0776 27.4988L122.819 85.2399C124.452 86.8729 123.705 89.6612 121.474 90.259L42.598 111.394C40.3673 111.991 38.3261 109.95 38.9238 107.719L60.0585 28.8436Z",
    fill: "#61CB0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.719 38.9243C109.95 38.3266 111.991 40.3679 111.393 42.5986L90.2586 121.474C89.6609 123.705 86.8725 124.452 85.2395 122.819L27.4984 65.0781C25.8654 63.4451 26.6126 60.6568 28.8433 60.059L107.719 38.9243Z",
    fill: "#61CB0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.474 60.059C123.705 60.6567 124.452 63.4451 122.819 65.0781L65.078 122.819C63.445 124.452 60.6566 123.705 60.0589 121.474L38.9242 42.5985C38.3265 40.3678 40.3677 38.3266 42.5984 38.9243L121.474 60.059Z",
    fill: "#61CB0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2394 27.4986C86.8724 25.8656 89.6608 26.6128 90.2585 28.8435L111.393 107.719C111.991 109.95 109.95 111.991 107.719 111.393L28.8432 90.2588C26.6124 89.6611 25.8653 86.8727 27.4983 85.2397L85.2394 27.4986Z",
    fill: "#61CB0E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4478 78.2211L68.052 86.8254L92.3005 62.5769",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.616 19.5552C225.616 19.5552 180.248 39.8926 184.942 96.2116L240.478 122.807C236.568 64.141 282.718 46.1503 282.718 46.1503L225.616 19.5552Z",
    fill: "#C8E2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.601 96.2117L240.138 122.807",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.0586,
    y: 185.471,
    width: 43.0593,
    height: 1.56442,
    transform: "rotate(28.7274 99.0586 185.471)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.638,
    y: 210.354,
    width: 43.0593,
    height: 1.56442,
    transform: "rotate(-45 112.638 210.354)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.334,
    y: 173.443,
    width: 42.005,
    height: 1.56442,
    transform: "rotate(28.7274 109.334 173.443)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.9487,
    y: 199.737,
    width: 42.005,
    height: 1.56442,
    transform: "rotate(-45 98.9487 199.737)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPaymentOrder);
export default __webpack_public_path__ + "static/media/success-payment-order.b1ca7597c30f2c48e7f888c45fb20f0b.svg";
export { ForwardRef as ReactComponent };